const integrations = {
  backToIntegrations: 'Integrações',
  enabled: 'ATIVADA',
  outOfService: 'Em breve...',
  enable: 'Habilitar',
  app: {
    actions: {
      disable: {
        button: 'Desativar',
        success: 'Integração desativada com sucesso',
        failure: 'Ocorreu um erro ao desabilitar a integração',
        confirmModal: {
          header: 'Confirmar desconexão de integração',
          body: 'Para desativar a integração, insira a palavra \'desativar\' no campo de texto e confirme.',
          verificationPhrase: 'desativar',
        },
      },
      oneTwoWayVerificationModal: {
        toOneWayInstructions: 'Para mudar a integração para unidirecional, digite a palavra \'mudar\' no campo de texto e confirme',
        toTwoWayInstructions: 'Para mudar a integração para bidirecional, digite a palavra \'mudar\' no campo de texto e confirme.',
        verificationPhrase: 'mudar',
      },
      submit: {
        success: 'Ação personalizada iniciada com sucesso',
        failure: 'Ocorreu um erro ao iniciar a ação de customização',
      },
    },
  },
  form: {
    submit: {
      enable: {
        success: 'Integração ativa com sucesso. As ações personalizadas foram iniciadas...',
        failure: 'Não é possível habilitar a integração. Verifique sua configuração de autenticação',
      },
    },
  },
};

export default integrations;
